import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { isEqual } from 'lodash';
import { NgxPermissionsService } from 'ngx-permissions';
import { distinctUntilChanged, map, Subscription } from 'rxjs';
import { Permissions } from '../permission-def';

// reference:
// https://github.com/angular/angular/blob/main/packages/common/src/pipes/async_pipe.ts

@Pipe({
  name: 'hasPermissions',
  pure: false,
})

export class HasPermissionsPipe implements PipeTransform, OnDestroy {

  private _ref: ChangeDetectorRef | null;
  private _latestValue?: Permissions | Permissions[];
  private _hasPermissions: boolean = false;
  private _subscription?: Subscription;

  // wait for global permissions to be set after firebase auth
  private permissionsSet$ = this.ngxPermission.permissions$.pipe(
    map(permissions => Object.keys(permissions).length > 0),
    distinctUntilChanged(),
  );

  constructor(
    private ngxPermission: NgxPermissionsService,
    private ref: ChangeDetectorRef,
  ) {
    this._ref = this.ref;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._ref = null;
  }

  transform(value: Permissions | Permissions[]): boolean {
    if (!isEqual(value, this._latestValue)) {
      this._latestValue = value;

      this._subscription?.unsubscribe();

      this._subscription = this.permissionsSet$.subscribe(permissionsSet => {
        if (permissionsSet) {
          this.ngxPermission.hasPermission(value)
            .then(hasPermissions => {
              this._hasPermissions = hasPermissions;
              this._ref.markForCheck();
            });
        }
      });
    }

    return this._hasPermissions;
  }
}
